import React from 'react';
import LoadingSpinner from '../../../../components/agent/UX/LoadingSpinner';

const SavedIndicator = ({ isSaving, lastSaved }) => {
  return (
    <div className="saved-indicator flex items-center gap-2 py-3 px-4 text-sm">
      {isSaving ? (
        <>
          <LoadingSpinner size="sm" variant="primary" />
          <span>Saving...</span>
        </>
      ) : lastSaved ? (
        <>
          <svg className="saved-icon shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M13.5 4L6 11.5L2.5 8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Saved automatically</span>
        </>
      ) : (
        <span>All changes saved</span>
      )}
    </div>
  );
};

export default SavedIndicator;
